// import lazyLoadView from "@router/lazyload-view";
import routeError from "@router/route-error";
import store from '@src/store'

export default [
    // 經銷會員驗證
    {
        path: '/dealer/validate/:token',
        name: 'dealer',
        meta: {
            async beforeResolve(routeTo, routeFrom, next) {
                try {
                    const token = routeTo.params.token
                    await store.dispatch('auth/tokenMatch', token)
                        .then((res) => {
                            if (res.code === 200) {
                                alert(res.message)
                                next({ name: 'login' })
                            } else {
                                alert(res.message)
                                next({ name: 'home' })
                            }
                        })
                    //   next()
                } catch (error) {
                    routeError(error, routeTo, next({ name: '404' }));
                }
            },
            // isLoginPage: false,
        },
    },
]